"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const next_components_text_info_n_1 = __importDefault(require("@gerenciatd/next.components.text-info-n"));
const next_components_icon_n_1 = __importDefault(require("@gerenciatd/next.components.icon-n"));
const next_components_custom_link_1 = __importDefault(require("@gerenciatd/next.components.custom-link"));
const next_app_controller_reducers_sagas_modals_reducer_1 = require("@gerenciatd/next.app-controller.reducers-sagas.modals-reducer");
const SegmentHandler_1 = __importDefault(require("../../ModalsContent/SegmentHandler"));
const constants_1 = require("../../constants");
const getPropsBySegment = (segment) => {
    switch (segment) {
        case constants_1.EMPRESAS:
            return {
                textProps: {
                    color: 'blue',
                },
                iconProps: {
                    color: 'blue',
                },
            };
        default:
            return {
                textProps: {
                    color: 'black',
                },
                iconProps: {
                    color: 'grey6',
                },
            };
    }
};
const SegmentSelector = ({ segment, taggingInfo, addModal }) => {
    const handleModal = () => {
        addModal({
            type: next_app_controller_reducers_sagas_modals_reducer_1.ELEMENT_TYPES.MODAL,
            id: 'segmentHandler',
            Element2Show: SegmentHandler_1.default,
            modalProps: {
                contentPosition: 'center--top',
                opacityLayoutColor: 'white',
                inSceneEffect: 'fadeIn',
                outSceneEffect: 'fadeOut',
                closeByClickingOutside: true,
            },
            elementProps: {
                segment,
                taggingInfo,
            },
        });
    };
    let selectItem = null;
    if (segment === 'empresas') {
        selectItem = constants_1.SEGMENT_LIST_EMP.find((item) => item.id === segment);
    }
    else {
        selectItem = constants_1.SEGMENT_LIST_GP.find((item) => item.id === segment);
    }
    if (!selectItem || !selectItem.label) {
        return null;
    }
    const { textProps, iconProps } = getPropsBySegment(segment);
    const currentTaggingInfo = Object.assign(Object.assign({}, taggingInfo), { componentProduct: '', componentContent: 'deplegable-segmento', componentVariation: 'all-mobile' });
    return (react_1.default.createElement("div", { className: "SegmentSelector" },
        react_1.default.createElement(next_components_custom_link_1.default, { component: "button", className: "linkss", onClick: handleModal, ariaLabel: "ver segmentos", title: "ver segmentos", taggingInfo: currentTaggingInfo }),
        react_1.default.createElement(next_components_text_info_n_1.default, Object.assign({ segment: segment, className: "currentSegment", size: "caption01", text: selectItem.label }, textProps)),
        react_1.default.createElement(next_components_icon_n_1.default, Object.assign({ segment: segment, id: "CheuronDown", size: 12, className: "cheuronSS" }, iconProps))));
};
const mapDispatchToProps = (dispatch) => ({
    addModal: (data) => dispatch(next_app_controller_reducers_sagas_modals_reducer_1.actions.addModal(data)),
});
exports.default = (0, react_redux_1.connect)(null, mapDispatchToProps)(SegmentSelector);
//# sourceMappingURL=index.js.map